import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { NotificationCollection } from '../index'

export const setupNotificationReplication = (
  collection: NotificationCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'notifications',
    displayName: 'Notification',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      userId: doc.userId,
      entityType: doc.entityType,
      entityId: doc.entityId,
      type: doc.type,
      title: doc.title,
      message: doc.message,
      actionUrl: doc.actionUrl,
      isRead: doc.isRead || false,
      readAt: doc.readAt ? (toTimestamp(doc.readAt) ?? new Date(doc.readAt).getTime()) : null,
      priority: doc.priority ?? 1,
      reminderId: doc.reminderId || null,
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy || null,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      userId: state.userId,
      entityType: state.entityType,
      entityId: state.entityId,
      type: state.type,
      title: state.title,
      message: state.message,
      actionUrl: state.actionUrl,
      isRead: state.isRead,
      readAt: toISOStringOrNull(state.readAt),
      priority: state.priority ?? 1,
      reminderId: state.reminderId || null,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy || null,
    }),
  })
